import { Component, Input } from '@angular/core'
import { faLock, faMicrophoneAltSlash } from '@fortawesome/pro-solid-svg-icons'
import {
    SESSION_ACTIVITY_TYPE_ANYTHING,
    SESSION_ACTIVITY_TYPE_DESK,
    SESSION_ACTIVITY_TYPE_MOVING,
    SESSION_DURATION_25_MINS,
    SESSION_DURATION_50_MINS,
    SessionActivityType,
} from '@app/core/_models'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faLampDesk, faPersonWalking, faShuffle } from '@fortawesome/pro-solid-svg-icons'
import { ButtonModule } from 'primeng/button'

const movingTooltip = 'Moving mode: For workouts, chores, and active tasks'
const anythingTooltip = "Anything mode: When they're juggling various tasks or still deciding"
const deskTooltip = 'Desk mode: For writing, emails, coding, and more'

@Component({
    selector: 'fm-session-indicator-icons',
    imports: [ButtonModule, FontAwesomeModule],
    templateUrl: './session-indicator-icons.component.html',
    styleUrl: './session-indicator-icons.component.scss',
})
export class SessionIndicatorIconsComponent {
    @Input() isQuietMode: boolean = false
    @Input() activityType: SessionActivityType
    @Input() showActivityType: boolean = true
    @Input() isLockedIn: boolean = false
    @Input() sessionDuration: number | null = null

    faMicrophoneAltSlash = faMicrophoneAltSlash
    activityIcon: any
    faLock = faLock

    public durationString: string | null = null

    ngOnInit(): void {
        this.setActivityIcon()
        this.setDurationString()
    }

    ngOnChanges() {
        this.setActivityIcon()
        this.setDurationString()
    }

    private setActivityIcon(): void {
        switch (this.activityType) {
            case SESSION_ACTIVITY_TYPE_ANYTHING:
                this.activityIcon = faShuffle
                break

            case SESSION_ACTIVITY_TYPE_DESK:
                this.activityIcon = faLampDesk
                break

            case SESSION_ACTIVITY_TYPE_MOVING:
                this.activityIcon = faPersonWalking
                break
        }
    }

    private setDurationString(): void {
        if (this.sessionDuration) {
            this.durationString = (this.sessionDuration / 60000).toString()
        } else {
            this.durationString = null
        }
    }
}
